<template>
  <div>
    <v-card class="rounded-lg pa-2 custom_card" flat>
      <v-card-title class="text-color">
        MillonVerified Credits
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-flex justify-start align-center">
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="#2661FF"
              size="30"
            ></v-progress-circular>
            <p v-else class="text-color title">
              {{ credits }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Validation',
  layout: 'default',
  data () {
    return {
      loading: false,
      credits: 0
    }
  },
  mounted () {
    this.credits = 0
  },
  async created () {
    await this.getCredits()
  },
  methods: {
    async getCredits () {
      try {
        this.loading = true
        const response = await axios.get('admin/millionVerifier/credits')
        this.credits = response.data.credits
      } catch (error) {
        Vue.noty.error('Error getting credits')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-color {
  color: #344054;
}
</style>
